module.exports = __webpack_public_path__ + "assets/images/9427b77b4ab96964c236103edeb9dc8d.png";